import { useIntl } from 'react-intl'
import {
  ContactPlain,
  MemberPlainDefault,
  TeamPlainDefault
} from '../../../stories/atoms/icons/users'
import NotFoundComponent from '../../../stories/molecules/not-found'
import { projectMembersTabOptions } from '../../constants'
import { ProjectMembersTabEmptyMembersContainer } from '../../styled-components'
import { textStyleSizeOptions } from '../../../stories/fundamentals/text-styles/constants'

const iconStyle = {
  width: '60px',
  height: '60px',
  opacity: 0.5
}

const emptyStateByVariant = {
  [projectMembersTabOptions.MEMBERS]: {
    Icon: MemberPlainDefault,
    labelId: 'members'
  },
  [projectMembersTabOptions.TEAMS]: {
    Icon: TeamPlainDefault,
    labelId: 'teams_titleTeamGroups'
  },
  [projectMembersTabOptions.CONTACTS]: {
    Icon: ContactPlain,
    labelId: 'personas_contacts'
  }
}

const ProjectMembersEmptyList = ({
  variant = projectMembersTabOptions.MEMBERS
}) => {
  const { formatMessage } = useIntl()

  const { Icon, labelId } =
    emptyStateByVariant[variant] ??
    emptyStateByVariant[projectMembersTabOptions.MEMBERS]

  const memberType = formatMessage({ id: labelId })

  return (
    <ProjectMembersTabEmptyMembersContainer>
      <NotFoundComponent
        icon={<Icon style={iconStyle} />}
        header={formatMessage(
          { id: 'no_members_yet' },
          { member_type: memberType }
        )}
        headerSize={textStyleSizeOptions['TEXT-R']}
        description={formatMessage(
          { id: 'no_members_yet_description' },
          { member_type: memberType }
        )}
        descriptionSize={textStyleSizeOptions['TEXT-R']}
      />
    </ProjectMembersTabEmptyMembersContainer>
  )
}

export default ProjectMembersEmptyList
